export const mircoAcp = {} as any
/** PC端工作台的code */
export const CBIMWorkPlatform = 'CBIM_WorkPlatform'

export default {
  mircoAcp,
  CBIMWorkPlatform
}
